import PropTypes from "prop-types";
import BaseComponent from "../../../../../lib/components/BaseComponent";
import Window from "../../../../../lib/components/window/Window";
import HorizontalLayout from "../../../../../lib/components/layouts/HorizontalLayout";

import React, {createRef} from "react";
import SysUpload from "../../../../../lib/components/Upload";
import CM from "../../../../model/system/CM";
import {toast} from "react-toastify";
import AnalyseUpload from "../../../../../lib/model/service/entity/dto/AnalyseUpload";
import FieldSelectionContainer from "./FieldSelectionContainer";
import Import from "../../../../../lib/model/service/entity/dto/Import";
import GF from "../../../../../lib/utils/GF";
import VM from "../../../../../lib/model/system/VM";
import DataSource from "../../../../../lib/model/service/dataSource/DataSource";
import T from "../../../../model/system/text_translations/Translator";
import Button from "../../buttons/Button";
import Switch from "../../switch/Switch";

class Upload extends BaseComponent {

  constructor(props) {
    super(props);
    this.collectionId = '';
    this.fieldSelectionContainerRef = createRef();
    this.sysUploadRef = createRef();
    this.state = {
      cbDeleteChecked: false, fileUploaded: false
    };
  }

  componentDidMount() {
    super.componentDidMount();
    this.setState(this.state);
  }

  analyseUpload(response) {
    let entityDef = this.props.dataSource.getEntityDef();
    let dtoAnalyseUpload = new AnalyseUpload(response.data.id, entityDef.baseDef.name);
    dtoAnalyseUpload.setProperties(this.props.dataSource.getDtoProperties());

    CM.get().doJsonAjax(CM.get().getServiceUrl('DoctrineEntityService'), dtoAnalyseUpload, (response) => {
      if (response.success) {
        this.collectionId = response.data.id;
        this.fieldSelectionContainerRef.current.initMapping(response);
        this.state.fileUploaded = true;
        this.setState(this.state);
      } else {
        toast.error(response.message);
      }
    });
  }

  doImport() {
    if (GF.checkNotNull(this.fieldSelectionContainerRef.current)) {
      let fieldMapping = this.fieldSelectionContainerRef.current.getFieldMapping();
      let entityName = this.props.dataSource.getEntityDef().baseDef.name;
      let dtoImport = new Import(entityName, this.collectionId, fieldMapping, this.state.cbDeleteChecked);
      dtoImport.setProperties(this.props.dataSource.getDtoProperties());

      CM.get().doJsonAjax(CM.get().getServiceUrl('DoctrineEntityService'), dtoImport, (response) => {
        if (response.success) {
          VM.get().clearData('CM.doJsonAjaxCache_' +
            DataSource.buildEntityCacheKey(this.props.dataSource.dtoProperties.campaignId, entityName, 'Read'));
          toast.success('Import erfolgreich');
          CM.get().getPanel().horizontalTabBarRef.current.removeTab(this.props.entity.uploadTabId);
        } else {
          toast.error(response.message);
        }
      });
    } else {
      toast.warning('Bitte zuerst eine Datei hochladen!');
    }
  }

  onUploadDone(response) {
    this.collectionId = response.data.id;
    this.sysUploadRef.current.setImportId(response.data.id);

    this.analyseUpload(response);
  }

  cbDeleteChanged(e, id, checked) {
    this.state.cbDeleteChecked = checked;
  }

  render() {
    let dtoProperties = this.props.dataSource.getDtoProperties();
    return <Window title={T.label_import()}>
      <SysUpload
        ref={this.sysUploadRef}
        title='Hochladen'
        onUploadDone={(response) => this.onUploadDone(response)}
        dtoProperties={dtoProperties}
        importId={this.collectionId}/>
      <FieldSelectionContainer ref={this.fieldSelectionContainerRef}/>
      {this.state.fileUploaded && <HorizontalLayout className='justify-end gap-2'>
        <Switch
          color='error'
          labelElement='Tabellendaten beim Importieren überschreiben!'
          checked={this.state.cbDeleteChecked}
          onChange={(e, id, checked) => this.cbDeleteChanged(e, id, checked)}/>
        <Button onClick={(e) => this.doImport(e)}>{T.label_do_import()}</Button>
      </HorizontalLayout>}
    </Window>;
  }
}

Upload.propTypes = {
  dataSource: PropTypes.object, campaignId: PropTypes.any, entity: PropTypes.object
}
export default Upload;
